export default "__VITE_ASSET__Ca$Ih5VI__"